import { ProfileResource, profileResource } from '@witkac/kartamiejska-resources';
import { Profile, ProfileFilter, ProfileType } from '@witkac/kartamiejska-shared';
import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';

import cards from './client/cards.module';
import groups from './client/groups.module';
import { EntityModule } from './entity.module';

/**
 * Moduł klienta
 *
 * @export
 * @class ClientModule
 * @extends {AbstractModule<ProfileResource>}
 */
export class ClientModule extends EntityModule<Profile, ProfileResource> {
  constructor() {
    super(profileResource);
    /**
     * Stan store
     *
     * Zawiera dane klienta
     *
     * @memberof ClientModule
     */
    this.state = {
      ...this.state,
      data: {
        profile: undefined,
        login: undefined
      },
      id: undefined
    };

    this.mutations = {
      ...this.mutations,
      /**
       * Ustawia identyfikator klienta do store
       *
       * @param localState stan lokalny
       * @param id identyfikator klienta
       */
      setId(localState: any, id: number): void {
        localState.id = id;
      },
      /**
       * Zapisuje klienta do store
       *
       * @param localState stan lokalny
       * @param profile profil klienta
       */
      setEntity(localState: any, profile: any): void {
        localState.data.profile = profile;
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      },
      /**
       * Nadpisuje klienta do store
       *
       * @param localState stan lokalny
       * @param profile profil klienta
       */
      updateEntity(localState: any, profile: any): void {
        localState.data.profile = { ...localState.data.profile, ...profile };
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      }
    };

    const listAction = this.actions.list;
    this.actions = {
      ...this.actions,
      /**
       * Pobranie listy mieszkańców
       *
       * @param context context
       * @param filters filtry
       */
      list: (context: any, filters: ProfileFilter = {}): Promise<any> => {
        if (
          !filters.order &&
          !(filters.orderMultiple && filters.orderMultiple.length) &&
          !(filters.orderBy && filters.orderBy.length)
        ) {
          const desc = tryParseBoolean(filters.desc, false);
          filters.orderBy = [{ name: 'lastName', desc }, { name: 'firstName', desc }, { name: 'id', desc }];
        }
        return listAction(context, {
          desc: false,
          ...filters,
          type: ProfileType.CLIENT
        });
      },
      /**
       * Aktualizuje dane klienta
       *
       * @param context context
       * @param data profil klienta
       */
      update: (context: any, data: { id: number; profile: Profile }): Promise<void> => {
        const args = { ...data.profile };
        return this.resource.update(data.id as number, args).then(() => context.commit('updateEntity', data.profile));
      },

      /**
       * Nadpisanie metody by poprawnie listować dodanego Klienta
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<void>}
       */
      add: async (context: any, data: any): Promise<void> => {
        data.profile.userId = await this.resource.add(data);
        context.commit('add', data.profile);
        context.commit('incrementCount');
      }
    };

    /**
     * Submoduły klienta
     *  karty, historia, usługi, grupy
     *
     * @memberof ClientModule
     */
  }
  public modules = { cards, groups };
}
export default new ClientModule();
